import React from 'react';
import { map } from 'lodash';
import { scaleLinear } from '@visx/scale';

import { scaleColorTraffic } from 'js/utils/color';

import { CategoryLayout } from 'js/components/Charts/CategoryLayout';
import ConditionalLinkWrapper from '../ConditionalLinkWrapper';
import NotScorableQuestionResult from './NotScorableQuestionResult';
import ScorableQuestionResult from './ScorableQuestionResult';
import NoResponseQuestionResult from './NoResponseQuestionResult';
import UnscoredQuestionResult from './UnscoredQuestionResult';

function getQuestionResult(questionData) {
  if (questionData.responseCount === 0) {
    return NoResponseQuestionResult;
  }

  switch (questionData.type) {
    case 'single-select':
    case 'multi-select':
    case 'long-text':
      return NotScorableQuestionResult;

    case 'unscored-likert':
      return UnscoredQuestionResult;

    case 'likert':
    default:
      return ScorableQuestionResult;
  }
}

const AssessmentHistoryChart = ({
  dataMap,
  assessmentId,
  colors,
  categoryLookups,
  questionSetHref,
  questionHref,
}) => {
  const questionSets = assessmentId
    ? dataMap.assessments[assessmentId].questionSets
    : dataMap.questionSets;

  const color = scaleLinear({ domain: colors.domain, range: colors.range });

  return (
    <div className="row">
      <div className="col">
        <div className="assessment-history-chart">
          <div className="assessment-history-visualization" />
          <div className="assessment-history-questions">
            <CategoryLayout
              categoryLookups={categoryLookups}
              categories={dataMap?.categories}
              questionSets={questionSets}
              questionSetClassName="assessment-history-question-set"
              renderQuestionSetName={(questionSet) => (
                <span className="question-set-name">
                  <ConditionalLinkWrapper
                    wrap={!!questionSetHref}
                    href={questionSetHref}
                    parameters={[questionSet.key]}
                  >
                    {questionSet.displayName}
                  </ConditionalLinkWrapper>
                </span>
              )}
              renderQuestionSet={(questionSet, _palette) => {
                return (
                  <ul className="category-question-list">
                    {map(questionSet.questions, (q, qKey) => {
                      const QuestionResult = getQuestionResult(q);

                      return (
                        <QuestionResult
                          tag="li"
                          key={qKey}
                          color={color}
                          questionData={q}
                          questionHref={questionHref}
                          parameters={[questionSet.key, qKey]}
                        />
                      );
                    })}
                  </ul>
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AssessmentHistoryChart.defaultProps = {
  colors: {
    domain: scaleColorTraffic.domain(),
    range: scaleColorTraffic.range(),
  },
};

export const Glyph = (
  <svg
    viewBox="0 0 32 32"
    className="chart-glyph assessment-history-chart-glyph"
  >
    <rect x="2" y="2" width="11" height="11" className="box box-ul" />
    <rect x="19" y="2" width="11" height="11" className="box box-ur" />
    <rect x="2" y="19" width="11" height="11" className="box box-ll" />
    <rect x="19" y="19" width="11" height="11" className="box box-lr" />
  </svg>
);

export default AssessmentHistoryChart;
